module.exports = __webpack_public_path__ + "img/33_5.ef600ae0.png";